import { render, staticRenderFns } from "./PracticalDetail.vue?vue&type=template&id=7420a1c6&scoped=true&"
import script from "./PracticalDetail.vue?vue&type=script&lang=js&"
export * from "./PracticalDetail.vue?vue&type=script&lang=js&"
import style0 from "./PracticalDetail.vue?vue&type=style&index=0&id=7420a1c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7420a1c6",
  null
  
)

export default component.exports